<script lang="ts" setup>
import { ref, watch } from "vue";
import { useToast } from "vue-toastification";
import ChartHomesHeatingTypes from "../charts/ChartHomesHeatingTypes.vue";
import { getHomesHeatingTypesDashboard } from "@/services/api/chart.api";

const props = defineProps({
  token: {
    type: String,
  },
  showTitle: {
    type: Boolean,
    default: true,
  },
});

const homesHeatingTypes = ref<Record<string, { val: any; color: string }>>({});
const toaster = useToast();
const isLoading = ref(true);

watch(
  () => props.token,
  () => {
    if (props.token) {
      fetchHomesHeatingTypesData();
    } else {
      homesHeatingTypes.value = {};
    }
  },
  { immediate: true }
);

async function fetchHomesHeatingTypesData() {
  isLoading.value = true;
  console.log("HomesHeatingTypes calling getHomesHeatingTypesDashboard(" + props.token + ")");
  const response = await getHomesHeatingTypesDashboard(props.token);
  console.log("HomesHeatingTypes getHomesHeatingTypesDashboard response", response);
  if (response) {
    homesHeatingTypes.value = {}; 
    Object.entries(response.data).forEach(([key, val]) => {
      homesHeatingTypes.value[key] = { val, color: "" };
    });
  } else {
    toaster.error("Ophalen van de homes warmte types data is mislukt!");
  }
  isLoading.value = false;
}
</script>

<template>
  <div class="widget-item">
    <header v-if="showTitle">
      <h2>Type verwarming</h2>
      <div class="widget-actions">
          <information-dropdown id="overzicht-panden">
          <template v-slot:header>
            <h2>Type verwarming</h2>
          </template>
          <p>
            De Rijksoverheid wil de CO2-uitstoot verminderen door over te stappen op duurzame energie. Daarom kunt u vanaf 2050 in principe niet meer koken op gas of stoken op aardgas. Dan kan dit
            alleen nog met duurzame installaties.
          </p>
        </information-dropdown>
      </div>
    </header>
    <div class="widget-wrapper widget-chart">
      <loader-spinner v-if="isLoading" :is-loading="isLoading" :min-height="170"></loader-spinner>
      <ChartHomesHeatingTypes v-else :height="350" :width="100" :sourceData="homesHeatingTypes"></ChartHomesHeatingTypes>
    </div>
  </div>
</template>
